import { render, staticRenderFns } from "./ImageUploadBox.vue?vue&type=template&id=6336b2ec&scoped=true&"
import script from "./ImageUploadBox.vue?vue&type=script&lang=js&"
export * from "./ImageUploadBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336b2ec",
  null
  
)

export default component.exports